import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Header from "@/components/header_pc/index";
import Footer from "@/components/footer/index";
import Dialog from "@/components/Dialog/index";
import "./index.scss";

import { rootContext } from "@/context/rootContext";

const isFirefox = navigator.userAgent.indexOf("Firefox") > 0;
const unScalePage = ["/application"];
let scaleBite = 0.75;
let scaleWidth = 1700;

function PC() {
  const location = useLocation();
  const [isScale, setIsScale] = useState(false);

  const { setScale } = useContext(rootContext);

  // 页面缩放逻辑
  useEffect(() => {
    const scaleFun = autoSize;
    window.addEventListener("resize", scaleFun);
    scaleFun();

    return () => window.removeEventListener("resize", scaleFun);
  }, [isScale]);

  useEffect(() => {
    for (const path of unScalePage) {
      if (location.pathname === "/" || location.pathname.includes(path)) {
        setIsScale(false);
        return;
      }
    }
    setIsScale(true);
    if (location.pathname.includes("/signup")) {
      scaleWidth = 1500;
      scaleBite = 0.8;
    } else {
      scaleWidth = 1700;
      scaleBite = 0.75;
    }
    autoSize();
  }, [location]);

  const autoSize = () => {
    const ww = document.documentElement.clientWidth;
    if (isScale) {
      const scale = ww / scaleWidth < scaleBite ? ww / scaleWidth : scaleBite;
      setScale(scale);
      if (isFirefox) { //判断是否为火狐浏览器
        // 设置页面缩放比例
        document.getElementsByTagName("main")[0].setAttribute("style", `
          -webkit-transform: scale(${scale});
          -mod-transform: scale(${scale});
          transform: scale(${scale});
          transform-origin: center top`
        );
      } else {
        // 谷歌内核浏览器 页面等比缩放
        document.body.style.zoom = scale;
      }
    } else {
      if (isFirefox) {
        document.getElementsByTagName("main")[0].removeAttribute("style");
      } else {
        document.body.removeAttribute("style");
      }
    }
  };

  return (
    <div className={`wrap ${location.pathname.includes("signup") ? "bg1" : ""} ${isScale ? "" : "unscale"}`} id="wrap">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />

      <Dialog />
    </div>
  );
}

export default PC;
